import fetch from 'isomorphic-fetch'
import { getRootURL } from '../../../lib'

export const donor = () => (dispatch, getState) => {
	var body

  body = { limit: 12 }
  return fetch(getRootURL() + '/user/donor', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
	.then(response => {
    return Promise.resolve(response.json())
  })
}



// WEBPACK FOOTER //
// ./src/Parts/DonorListCard/actions/index.js